// import Analytics from "react-router-ga"
import ReactGA from "react-ga4"
import { useEffect } from "react"

export const GA_ID = "G-6WGEVDZCE4"
export const trackingConstants = {}

// why is this broken? I want an object with keys
export const Categories = {
  "Default": "-",
  "Sidebar": "Sidebar",
  "Topbar": "Topbar",
  "FeudPlanner": "FeudPlanner",
  "Draft": "Draft",
  "CreateShow": "CreateShow",
  "CreateProduction": "CreateProduction",
  "Setup": "Setup",
  "Office": "Office",
  "Rumble": "Rumble",
  "Repoint": "Repoint",
  "Alignment": "Alignment",
  "Simulate": "Simulate",
  "Memory": "Memory",
  "CMS": "CMS",
  "Layout": "Layout",
  "PANEL": "PANEL",
  "Tournament": "Tournament",
  "GuidedProduction": "GuidedProduction",
  "Settings": "Settings",
  "Saves": "Saves",
}

export const Actions = {
  "Default": "-",
  "Add": "Add",
  "Redirect": "Redirect",
  "Remove": "Remove",
  "Update": "Update",
  "Complete": "Complete",
  "GOOD": "GOOD",
  "BAD": "BAD",
  "RESIZE_END": "RESIZE_END",
  //memory game related
  "FLIP": "FLIP",
  "MEMORY_FINISH": "MEMORY_FINISH",
  "NEUTRAL": "NEUTRAL",
  "Bracket": "Bracket",
  "Toggle": "Toggle",
  "Filter": "Filter",
  "Click": "Click",
  "Create": "Create",
  "Delete": "Delete",
  "Navigate": "Navigate",
  "Duplicate": "Duplicate",
  "Import": "Import",
  "Export": "Export",
  "Reset": "Reset",
  "Download": "Download",
  "Upload": "Upload",
  "CalendarDateShow": "CalendarDateShow",
  "Save": "Save",
  "Randomise": "Randomise",
  "RangeCreated": "RangeCreated",
  "Load": "Load",
  "DragEnd": "DragEnd",
  "Simulate": "Simulate",
}

export const initGA = (trackingId = GA_ID) => ReactGA.initialize([{ trackingId }], { debug: true })

const defaultOptions = { "label": "-", "value": 0 }

export const trackEv = (category = Categories.Default, action = Actions.Default, options = defaultOptions ) => {
  try {
    // if (process.env.NODE_ENV === "development") {
    console.log("ReactGA.event", { category, action, options })
    // }
    ReactGA.event({
      category,
      action,
      ...options
    })
  } catch (error) {
    console.error(error)
  }
}

export const useTracking = () => {
  useEffect(() => {
    initGA(GA_ID)

    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, [])
}

const AnalyticsWrapper = ({ children, }) => {
  useTracking()

  return children
  // return <Analytics id={GA_ID}>{children}</Analytics>
}

export default AnalyticsWrapper
